import React from 'react';
import { styled } from '@linaria/react';
import Logos from './Logos';
import PolicyLinks from './PolicyLinks';
type Props = {
  children?: JSX.Element | (JSX.Element | boolean)[];
  policyAndLogoShow?: boolean;
};
const IDLayout = (props: Props) => {
  const {
    children,
    policyAndLogoShow = true
  } = props;
  return <Wrapper>
      {children}
      {policyAndLogoShow && <>
          <PolicyLinks />
          <Logos />
        </>}
    </Wrapper>;
};
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w1eil6in",
  propsAsIs: false
});
export default IDLayout;

require("./index.linaria.module.css!=!../../../../node_modules/.pnpm/@linaria+webpack5-loader@4.1.17_webpack@5.83.1/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");